module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-36.c777bad8.jpg";